export default __webpack_public_path__ + "static/media/dark22.d758537b.png";